import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { InitialModel, UserModel } from '../../../models/user.model';
import { getUserInitials } from '../../../utils/user.utils';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AvatarComponent {
  @Input() user: UserModel;
  @Input() placeholderBackgroundColor: string = null;
  @Input() placeholderColor: string = null;
  @Input() size: 'x-small' | 'small' | 'medium' | 'large' = 'medium';
  public avatarLoaded = false;
  public userInitials: InitialModel;

  public ngOnInit(): void {
    this.userInitials = getUserInitials(this.user);
  }

  public get avatar(): string | File {
    if (this.user?.avatar) {
      return this.user.avatar;
    }
    if (this.user?.avatarPath) {
      return environment.authority_short + this.user.avatarPath;
    }
    return null;
  }
}
